/* Pre-order button label.
   Shopify does not forward content_for arguments to a static block, so the
   theme's own add-to-cart label never arrives and the button falls back to its
   translated default. This rewrites it in the DOM, on the product page and in
   the quick-add modal. Only a button reading the theme's own "add to cart"
   wording is touched, so a sold-out variant keeps saying so.
   Runs on load, on a short poll, and on any mutation — the theme rewrites the
   label itself at a moment that varies by locale. */
(function () {
  var tag = document.querySelector('script[data-preorder-label]');
  if (!tag) return;
  var label = tag.getAttribute('data-preorder-label');
  var match = (tag.getAttribute('data-preorder-match') || '').trim();
  if (!label || !match) return;

  function relabel() {
    var notices = document.querySelectorAll('.fit-po, .fit-poq');
    for (var i = 0; i < notices.length; i++) {
      var scope = notices[i].closest('[data-quick-add-modal-body], .shopify-section, .product-details-section');
      if (!scope) continue;
      var t = scope.querySelectorAll('.add-to-cart-text__content');
      for (var j = 0; j < t.length; j++) {
        var b = t[j].closest('button');
        if (b && b.disabled) continue;
        if (t[j].textContent.trim() !== match) continue;
        t[j].textContent = label;
      }
    }
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; relabel(); });
  }

  relabel();
  document.addEventListener('DOMContentLoaded', schedule);
  window.addEventListener('load', schedule);

  var tries = 0;
  var timer = setInterval(function () {
    schedule();
    if (++tries > 20) clearInterval(timer);
  }, 250);

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();